<template>
  <div>
    <static-fullscreen-card v-show="!idItemShow">
      <template v-slot:title>
        <v-text-field
          class="pt-1"
          v-show="showGoodFind"
          v-model="goodFind"
          label="Поиск по товару"
          dense
          hide-details
          outlined
          clearable
          @blur="onFindBlur()"
          validate-on-blur
          @change="findByGoods(goodFind)"
          @click:clear="onFindBlur('clear')"
          append-icon="mdi-magnify"
          autofocus
        />
        <v-btn v-show="!showGoodFind" icon @click="showGoodFind = !showGoodFind">
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </template>
      <template v-slot:actions>
        <a-btn-refresh @click="$refs.table.updateData()" />
        <a-btn-add :icon="'far fa-plus-square'" :title="'Создать документ'" v-if="getAccess('documents.orderGoods.create')" @click="createNew()" />
      </template>
      <portal to="v-main">
        <edit-dialog v-model="showEditDialog" v-if="showEditDialog" :api="url" :m="m" :id="idEdit"></edit-dialog>
      </portal>
      <a-table-f-api
        ref="table"
        :api="url"
        :model="getModelList(m)"
        :useQuery="false"
        :defaults="defaults"
        :selectedRows="selectedRows"
        @update-data="updateData($event)"
        @click="
          counter += 1;
          onDetectClick($event);
        "
      >
      </a-table-f-api>
      <popup-window v-if="infoSnack" :type="3" :data="infoData" :model="infoModel" />
    </static-fullscreen-card>
    <ViewItem v-if="idItemShow" :idShow="idItemShow" @close="itemShowClose($event)" />
    <popup-menu v-model="popumMenuShow" :items="popupMenuList" :position="popupMenuPosition" @click="onClickMenu($event)" />
  </div>
</template>

<script>
import { getAccess, genModel, doubleClickDetect, keyDetect, popupMenu } from "@/components/mixings";

export default {
  mixins: [getAccess, genModel, doubleClickDetect, keyDetect, popupMenu],
  components: {
    editDialog: () => import("./dialogs/orderCreateDialog"),
    ViewItem: () => import("./views/orderGoodsView"),
  },
  data() {
    return {
      idEdit: 0,
      idItemShow: 0,
      showEditDialog: false,
      title: "",
      m: this.$store.getters["config/get"].models.documentOrderGoods,
      url: "/accounting/doc/order_good",

      infoData: null,
      infoModel: null,
      total_price: null,
      goodFind: "",
      goodFindText: "",
      showGoodFind: !false,
    };
  },
  created() {
    this.$root.title = "Заказы товаров";
  },
  computed: {
    defaults() {
      return {
        sort: { key: "date_doc", order: "DESC" },
        filters: {},
        paramName: "documentOrder",
        where: this.getAccess("documents.orderGoods.viewAll") ? {} : { createdby_id: this.$root.profile.id },
      };
    },
    permit() {
      return this.getAccess("menu.documentOrder");
    },
    infoSnack() {
      if (this.keysModified) {
      }
      let res = this.keys?.ctrl;
      this.infoData = null;
      this.infoModel = null;
      if (res) this.showOrderDetail();
      return res;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.$refs.table.updateData();
      }
    },
    goodFindText(v) {
      this.$refs.table.filters["goods_table.name"] = v ? { condition: "LIKE", value: "%" + v + "%" } : "";
      this.$refs.table.updateData();
    },
  },
  methods: {
    onFindBlur(e = "blur") {
      if (e == "clear") this.findByGoods("");
      else this.findByGoods(this.goodFind);
    },
    findByGoods(e) {
      this.goodFindText = e;
      this.showGoodFind = !!e;
    },
    itemShowClose() {
      this.loading = true;
      this.$refs.table.updateRowData(this.idItemShow);
      this.loading = !true;
      this.idItemShow = 0;
    },
    async showOrderDetail() {
      let id = this.selectedRows[0];
      if (!id) return;
      let data;
      let model;
      const d = await this.$axios.get(this.url + "/" + id);
      if (d.data && d.data.data) {
        let data = d.data.data.data_table;
        model = this.m.listDetail.filter(el => ["name", "amount", "price_real"].includes(el.name));
        this.infoData = data;
        this.infoModel = model;
      }
    },
    onSingleClick(d) {
      if (d.field?.isMenu) {
        if (d.field.name == "order_for") {
          let name = d.row.type == 1 ? "object" : d.row.type == 2 ? "office" : "storage";

          this.showPopupMenu(name, { id: d.row.object_code }, d.event);
        } else this.showPopupMenu(d.field.name, d.row, d.event);
      }
    },
    onDoubleClick(d) {
      this.onClickRow(d);
    },
    onClickRow(d) {
      this.idItemShow = d.row.id;
      return;
      this.$router.push({ name: "ordersGoods_view", params: { id: d.row.id } });
    },
    createNew() {
      this.showEditDialogFun(0);
    },
    showEditDialogFun(id) {
      this.idEdit = id;
      this.showEditDialog = true;
    },
    updateData(v) {},
  },
};
</script>
